module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-arrows-11384f84194e591ca4eda5ea458d8fd3.svg";